import actionTypes from '../actionTypes';

export const clientToken = () => ({
  type: actionTypes.PAYMENT_CLIENT_TOKEN_REQUEST,
});

export const checkout = (options) => ({
  type: actionTypes.PAYMENT_CHECKOUT_REQUEST,
  options,
});

export const getSubscription = (options) => ({
  type: actionTypes.PAYMENT_GET_SUBSCRIBE_REQUEST,
  options,
});

export const getCustomer = (options) => ({
  type: actionTypes.PAYMENT_GET_CUSTOMER_REQUEST,
  options,
});

export const subscribe = (options) => ({
  type: actionTypes.PAYMENT_SUBSCRIBE_REQUEST,
  options,
});

export const pay = (options) => ({
  type: actionTypes.PAYMENT_TRANSACTION_REQUEST,
  options,
});

export const cancelSubscribe = (options) => ({
  type: actionTypes.PAYMENT_CANCEL_SUBSCRIBE_REQUEST,
  options,
});



// WEBPACK FOOTER //
// src/redux/actions/payment.js